import { setupApiBridge } from '@/shared/api/authBridge';
import { env } from '@/shared/config/env';
import { persistor, store } from '@/shared/store';
import { startAppListeners } from '@/shared/store/listeners';

/**
 * Arranque fuera de React: conecta la capa HTTP con el store (token, refresh, alcance de la API) y
 * enciende los listeners (conectividad, sesión, sincronización de preferencias). Idempotente. En modo demostración instala antes el adaptador con datos incluidos.
 */
export async function bootstrapApp(): Promise<void> {
  // Modo demostración: el adaptador (y sus datos) se carga solo si hace falta, antes de la primera petición.
  if (env.demoMode) await import('@/shared/demo').then((m) => m.installDemoAdapter());
  setupApiBridge(store);
  startAppListeners(store, { persistor });
}
